import {baseAxios} from '../helper/axiosHelper';

export const testService = {
    helloWorld
};

function helloWorld() {

    return baseAxios.get('auth/test/')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

